// extracted by mini-css-extract-plugin
export var deleteModal = "_hp-0";